import { nop } from './baseActions'
import { findById } from '../services/FormulaService'
import { findFormulasAtivos } from '../services/FormulaAtivoService'
import { findAll as findAllUnidades } from '../services/UnidadeService'
import { findAll as findAllVeiculosUtilizacao, findById as findVeiculoById } from '../services/VeiculoUtilizacaoService'
import { searchByRef as searchVeiculos } from '../services/SearchVeiculoUtilizacaoService'
import { findLogsByFormula } from '../services/FormulaLogsService'
import { findAllMedicosByFarmacia } from '../services/FindMedicosService'

const setFormula = formula => {
  return {
    type: 'FORMULA_EDIT_SET_FORMULA',
    payload: formula
  }
}

const setAtivos = ativos => {
  return {
    type: 'FORMULA_EDIT_SET_ATIVOS',
    payload: ativos
  }
}

const setUnidades = unidades => {
  return {
    type: 'FORMULA_EDIT_SET_UNIDADES',
    payload: unidades
  }
}

const setMedicos = medicos => {
  return {
    type: 'FORMULA_EDIT_SET_MEDICOS',
    payload: medicos
  }
}

const setVeiculosUtilizacao = veiculosUtilizacao => {
  return {
    type: 'FORMULA_EDIT_SET_VEICULOS_UTILIZACAO',
    payload: veiculosUtilizacao
  }
}

const setVeiculoUtilizacao = veiculoUtilizacao => {
  return {
    type: 'FORMULA_EDIT_SET_VEICULO_UTILIZACAO',
    payload: veiculoUtilizacao
  }
}

export const setGoBack = path => {
  return {
    type: 'FORMULA_EDIT_SET_GO_BACK',
    payload: path
  }
}

const setLogs = logs => {
  return {
    type: 'FORMULA_EDIT_SET_LOGS',
    payload: logs
  }
}

export const clearFormula = () => {
  return {
    type: 'FORMULA_EDIT_CLEAR_FORMULA'
  }
}

export const fetchAtivosByFormula = (farmaciaId, formulaId) => {
  return async dispatch => {
    try {
      const ativos = await findFormulasAtivos(farmaciaId, formulaId);

      return dispatch(setAtivos(ativos));
    } catch (e) {
      return dispatch(nop());
    }
  }
}

export const fetchById = (farmaciaId, id) => {
  return async dispatch => {
    try {
      const formula = await findById(farmaciaId, id);

      return dispatch(setFormula(formula));
    } catch (e) {
      return dispatch(nop());
    }
  }
}

export const fetchUnidades = farmaciaId => {
  return async dispatch => {
    try {
      const unidades = await findAllUnidades(farmaciaId);

      return dispatch(setUnidades(unidades));
    } catch (e) {
      return dispatch(nop());
    }
  }
}

export const fetchMedicos = farmaciaId => {
  return async dispatch => {
    try {
      const medicos = await findAllMedicosByFarmacia(farmaciaId);

      return dispatch(setMedicos(medicos));
    } catch (e) {
      return dispatch(nop());
    }
  }
}

export const fetchVeiculosUtilizacao = farmaciaId => {
  return async dispatch => {
    try {
      const veiculosUtilizacao = await findAllVeiculosUtilizacao(farmaciaId);

      return dispatch(setVeiculosUtilizacao(veiculosUtilizacao));
    } catch (e) {
      return dispatch(nop());
    }
  }
}

export const fetchVeiculoUtilizacaoById = (farmaciaId, id) => {
  return async dispatch => {
    try {
      const veiculoUtilizacao = await findVeiculoById(farmaciaId, id);

      return dispatch(setVeiculoUtilizacao(veiculoUtilizacao));
    } catch (e) {
      return dispatch(nop());
    }
  }
}

export const searchVeiculosUtilizacao = (farmaciaId, ref) => {
  return async dispatch => {
    try {
      const veiculosUtilizacao = await searchVeiculos(farmaciaId, ref);

      return dispatch(setVeiculosUtilizacao(veiculosUtilizacao));
    } catch (e) {
      return dispatch(nop());
    }
  }
}

export const fetchLogsByFormula = (farmaciaId, formulaId) => {
  return async dispatch => {
    try {
      const logs = await findLogsByFormula(farmaciaId, formulaId);

      return dispatch(setLogs(logs));
    } catch (e) {
      return dispatch(nop());
    }
  }
}
